import { useTranslation } from "react-i18next";
import config from "utils/globals";
import { useSelector } from "react-redux";

const Amount = ({ data }) => {
  const { t } = useTranslation();
  const pmaOnboarding = useSelector((state) => state?.pmaReducer?.onboarding);

  return (
    <div className="display-demibold bg-white shadow-lg rounded-lg px-4 py-5 ">
      <div className=" text-center text-gray-4  border-b-gray--7 border-dotted border-b pb-4 mb-4">
        {config.numberSeparator(data?.amount)}
        <span className="body-14px-medium mr-1">{t("rial")}</span>
      </div>
      <div className="flex justify-between items-center">
        <div className="body-14px-regular text-gray-0">{t("about")}</div>
        <div className="flex gap-2">
          <span className="body-14px-demibold text-gray-4">
            {`${t("pma-onboarding.investing-portfolio")} ${pmaOnboarding?.name
              }`}
          </span>
          {pmaOnboarding?.logo && (
            <img
              src={pmaOnboarding?.logo}
              alt={pmaOnboarding?.name}
              className="w-6 h-6 rounded"
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default Amount;
